import { api } from "./api";

export interface ActivityLog {
  id: number;
  log_name: string;
  description: string;
  subject_type: string;
  subject_id: number;
  subject_name?: string;
  subject_sku?: string;
  causer_name: string | null;
  causer_id: number | null;
  user_responsible: {
    name: string | null;
    email: string | null;
    is_admin: boolean;
    display_name: string;
  };
  properties: {
    old?: Record<string, any>;
    attributes?: Record<string, any>;
  } | null;
  created_at: string;
}

export const activityLogService = {
  async list(params: {
    description?: string;
    date_from?: string;
    date_to?: string;
    page?: number;
    per_page?: number;
  }) {
    const { data } = await api.get("/api/admin/activity-log", { params });
    return data;
  },
};
